(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kora-zodiac-personalization"] && !Shopify.designMode) return;
  try {
    class KoraZodiacPersonalization extends HTMLElement {
    constructor() {
      super();
      this.handlePickerChange = this.handlePickerChange.bind(this);
      this.handleSignChange = this.handleSignChange.bind(this);
    }

    connectedCallback() {
      this.picker =
        this.closest('.product-details')?.querySelector('variant-picker') ||
        document.querySelector(`variant-picker[data-section-id="${CSS.escape(this.dataset.sectionId || '')}"]`);
      this.picker?.addEventListener('change', this.handlePickerChange);
      this.addEventListener('change', this.handleSignChange);
      this.updateFromPicker();
    }

    disconnectedCallback() {
      this.picker?.removeEventListener('change', this.handlePickerChange);
      this.removeEventListener('change', this.handleSignChange);
    }

    handlePickerChange(event) {
      const target = event.target;
      if (!(target instanceof HTMLSelectElement || target instanceof HTMLInputElement)) return;

      const optionName =
        target instanceof HTMLSelectElement
          ? target.selectedOptions[0]?.dataset.optionName
          : target.dataset.optionName;

      if (optionName !== this.dataset.optionName) return;
      this.updateCount(this.countFromValue(target.value));
    }

    handleSignChange(event) {
      if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-zodiac-select]')) return;
      this.updateCompletion();
    }

    updateFromPicker() {
      if (!this.picker) return;

      const controls = Array.from(this.picker.querySelectorAll('select, input:checked'));
      const control = controls.find((item) => {
        if (item instanceof HTMLSelectElement) {
          return item.selectedOptions[0]?.dataset.optionName === this.dataset.optionName;
        }
        return item instanceof HTMLInputElement && item.dataset.optionName === this.dataset.optionName;
      });

      if (control instanceof HTMLSelectElement || control instanceof HTMLInputElement) {
        this.updateCount(this.countFromValue(control.value));
      }
    }

    countFromValue(value) {
      const match = String(value).match(/\d+/);
      return Math.min(3, Number(match?.[0] || 0));
    }

    updateCount(count) {
      this.dataset.count = String(count);
      this.hidden = count === 0;

      const rows = Array.from(this.querySelectorAll('[data-zodiac-row]'));
      rows.forEach((row, index) => {
        const select = row.querySelector('[data-zodiac-select]');
        const active = index < count;

        if (!(select instanceof HTMLSelectElement)) return;

        select.disabled = !active;
        select.required = active;
        if (!active) select.value = '';
      });

      this.updateCompletion();
    }

    updateCompletion() {
      const activeSelects = Array.from(this.querySelectorAll('[data-zodiac-select]:not(:disabled)'));
      const complete = activeSelects.every(
        (select) => select instanceof HTMLSelectElement && select.value !== ''
      );
      const requiresSelection = activeSelects.length > 0 && !complete;

      this.dataset.complete = String(complete);
      if (requiresSelection) {
        this.dataset.requiresSelection = 'true';
      } else {
        delete this.dataset.requiresSelection;
      }

      const status = this.querySelector('[data-zodiac-status]');
      if (status instanceof HTMLElement) status.hidden = !requiresSelection;
    }
  }

  if (!customElements.get('kora-zodiac-personalization')) {
    customElements.define('kora-zodiac-personalization', KoraZodiacPersonalization);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kora-discount-badge-source')) {
    class KoraDiscountBadgeSource extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => this.updateBadge());
      }

      updateBadge() {
        const price = Number(this.dataset.price);
        const compareAtPrice = Number(this.dataset.compareAtPrice);
        const productCard = this.closest('product-card');
        const scope = productCard || this.closest('.shopify-section, dialog');
        const target = productCard?.querySelector('.card-gallery') || scope?.querySelector('media-gallery');

        if (!target) return;

        let badge = target.querySelector('.kora-discount-badge');

        if (!(compareAtPrice > price) || price <= 0) {
          badge?.remove();
          return;
        }

        const percentage = Math.round(((compareAtPrice - price) * 100) / compareAtPrice);

        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'kora-discount-badge';
          target.append(badge);
        }

        badge.textContent = `-${percentage}%`;
      }
    }

    customElements.define('kora-discount-badge-source', KoraDiscountBadgeSource);
  }
  } catch(e) { console.error(e); }
})();

})();
